module.exports = __webpack_public_path__ + "img/step-1.4aec2dc8.png";